import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { AppService, CoreTypes, IncidentTypes, LabelValue } from 'common-cloudstudio';
import { Subscription } from 'rxjs';
import { IncidentService } from '../../../services/incident.service';

export interface IncidentAttachment extends CoreTypes.IncidentAttachment { 
  FileType?:string
}


@Component({
  selector: 'app-incident-attachments',
  templateUrl: './IncidentAttachments.component.html',
  styleUrls: ['./IncidentAttachments.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IncidentAttachmentsComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => IncidentAttachmentsComponent),
      multi: true,
    }
  ]
})
export class IncidentAttachmentsComponent implements OnInit, OnDestroy, ControlValueAccessor { 
  @ViewChild("file") myFileRef: ElementRef;
  _data: IncidentAttachment = new CoreTypes.IncidentAttachment();
  @Input('data')
  set data(data: string) {
    this.writeValue(data);
  }
  get data() {
    return JSON.stringify(this._data);
  }
  @Input() editing: boolean = false;
  onChange = (_:any) => { }
  onTouch = () => { }
  fileModels: {
    fileModel?: any;
    fileName: string;
    file64: any;
    paramName?: string;
    description: string;
    label?: string;
    fileType: string;
    allowedExtensions?: string[],
    errors?: string;
  }[] =[];
  descriptionClone: string;
  displayFile:{
    type: string,
    file64?:any,
    url: string
  }
  isDisabled: boolean;

  _fileTypeList: LabelValue<number>[] = [{label: 'Imagen', value:1 }, { label: 'Audio', value:2 },{ label: 'Video', value:3 },{ label: 'Documento', value:4 }];
  _accepFileTye:string[] = [".jpg, .png, .jpeg, .gif, .svg"];
  _fileName: string;
  fileTypeMapping = IncidentTypes.FileTypeMapping;
  form: UntypedFormGroup = this.fb.group({
    fileType: [this._fileTypeList[0], ],
    fileDescription:[''],
    fileModel:['']
  });
  _fileList: File[] = [];
  fileLoader = 0;
  _file64: any;
  errorMess = "";
  subscriptions: Subscription[] = [];
  
  constructor(
    private fb: UntypedFormBuilder,
    public _appService: AppService,
    public sanitizer: DomSanitizer,
    private incidentService: IncidentService
  ) { }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  public validate() {
    let errors: ValidationErrors = {};
    Object.keys(this.form.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.form.get(key).errors;
      if (controlErrors != null) {
        errors[key] = controlErrors;
      }
    });
    return errors;
  }

  ngOnInit(): void { 
    this.getAttachmentTypes();
    this.subscriptions.push(this.fileDescription.valueChanges.subscribe(value => {
      setTimeout(() => {
        this._data.Description = value;
        this.onInput();
      }, 100);
    }));

  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  
  onInput() {
    // this.checkFields();
    this.onTouch();
    this.onChange(JSON.stringify(this._data));
  }

  async getAttachmentTypes() {
    let attachmentFullList = await this.incidentService.getIncidentAttachmentTypes();
    // attachmentFullList.map(x => {return {label: x.IncidentAttachmentTypeName, value : x.IncidentAttachmentTypeID} });
  }

  writeValue(value: any): void {
    if (value) {
      (typeof value === "object") ? this._data = value : this._data = JSON?.parse(value);
      let fileType = this.getFileType(this._data.FileName);
      this.fileModels.push({description: '', file64: this._data.File, fileName: this._data.FileName, fileType: fileType });
      this.fileDescription.setValue(this._data.Description);
      if(this.fileModels.length && this.myFileRef.nativeElement) this.myFileRef.nativeElement.disabled = true;  

    } else {
      this._data = new CoreTypes.IncidentAttachment();
    }
    let fileType2 = this._data?.FileName ? this.getFileType(this._data?.FileName) : '';
    let fileTypeSelect = this._fileTypeList.find(x => x.label == fileType2) ?? this._fileTypeList[0];
    this.fileType.setValue(fileTypeSelect);
    this.onInput();
  }

  getBase64(file, i) {
    // if (this.fileModel[0].errors) { this.fileModels[0].errors = null; }
    // if (this.fileModels[0].allowedExtensions.findIndex(f => file.name.toLowerCase().indexOf(f) > -1) < 0) {
    //   this.fileModels[0].errors = this._appService.CoreCommonLiterals.InvalidFileExtension;
    //   return;
    // }
    let fileExtension = this.getFileTypeExten(file.name);
    let fileExtensionRes = `.${fileExtension}`

    if (this.errorMess) { this.errorMess = ''; }
    let result = this._accepFileTye.filter(word=> word.includes(fileExtensionRes))
    if (!result.length){
      this.errorMess = this._appService.CoreCommonLiterals.InvalidFileExtension;
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(file);
    let fileType = this.getFileType(file.name);

    if(fileExtension == 'mp4'){
      reader.onloadend = async (e) => {
        this.fileModels.push({fileName: file.name, file64: reader.result, fileType : fileType, description: ''});
        setTimeout(() => this.fileLoader = 0, 100);
        this._file64 = reader.result;
      }
    } else {
     const url = URL.createObjectURL(file);
      reader.onload = (e) => {
        var img = new Image();
        img.src = e.target.result.toString();
        img.onload = () => { }  
        this._file64 = reader.result;

        this.fileModels.push({fileName: file.name, file64: reader.result, fileType : fileType, description: '',fileModel:url});
        setTimeout(() => this.fileLoader = 0, 100);
      };
    }

    setTimeout(() => {
      (this.fileModels.length && this.myFileRef?.nativeElement) ? this.myFileRef.nativeElement.disabled = true : this.myFileRef.nativeElement.disabled = false;
      this._data = {
        AccountID: this._appService.getAccountID(),
        DateTimeCreated: new CoreTypes.DateTimeDT(),
        Description: this.fileDescription.value,
        File: this._file64,
        FileName: file.name,
        IncidentAttachmentID:0,
        IncidentID: 0,
        FileType: fileType === 'image' ? 'Imagen' : fileType
      }
      this.onInput();
      
    }, 100);

    const url = URL.createObjectURL(file);
    reader.onerror = (error) => {
      this.fileLoader = 2;
      this.errorMess = error.toString();
    };
  }

  onFileChange(e) {
    this.fileLoader = 1;
    if (e.target.files.length < 1) { return; }
    for (var i = 0; i <= e.target.files.length - 1; i++) {
      var selectedFile = e.target.files[i];
      if (this.fileModels.indexOf(selectedFile.name) === -1) {
        this._fileList.push(selectedFile);
        let file = e.target.files[i];
        let size = (file.size / 1024).toFixed(2);
        var reader = new FileReader();
        this.getBase64(file, i);
        this._fileName = file.name;
        // this.errorMess = '';

      }
    }
    this.myFileRef.nativeElement.value = null;
  }

  getFileType(fileName) {
    const extension = fileName.split('.').pop().toLowerCase();
    const fileType = this.fileTypeMapping[extension];
    return fileType || 'unknown';
  }

  getFileTypeExten(fileName) {
    const extension = fileName.split('.').pop().toLowerCase();
    return extension || 'unknown';
  }
  
  deleteImage(index?) {
    this._fileName = null;
    this.fileModels.splice(index, 1);
    this._data = null;
    setTimeout(() => {
      (this.fileModels.length && this.myFileRef?.nativeElement) ? this.myFileRef.nativeElement.disabled = true : this.myFileRef.nativeElement.disabled = false;
    }, 100);
  }

  onSelectFileType() {
    if (this.fileType.value.value === 1) {
      this._accepFileTye = [".jpg, .png, .jpeg, .gif, .bmp, .svg"];
    } else if(this.fileType.value.value === 2) {
      this._accepFileTye = [".mp3, .ogg, .opus"];
    } else if(this.fileType.value.value=== 3) {
       this._accepFileTye = [".mp4, .avi"];
    } else if(this.fileType.value.value === 4) {
       this._accepFileTye = [".doc,.docx,.xml, .pdf, .xlsx"];
    }
  }

  get fileType() { return this.form.get('fileType'); }
  get fileDescription() { return this.form.get('fileDescription'); }
  get fileModel() { return this.form.get('fileDescription'); }
}
